import EcoTransesofageaEdit from "./components/EcoTransesofageaEdit.vue";
import EcoTransesofageaView from "./components/EcoTransesofageaView.vue";
import EcoTransesofageaList from "./components/EcoTransesofageaList.vue";

export default {
    EcoTransesofageaEdit,
    EcoTransesofageaView,
    EcoTransesofageaList,
};
